import { createSelector } from 'reselect';
import { ALL_GROUPS } from '../../filter-constants';

/**
 * Redux selectors for group + student data
 */

const selectStudentsByGroup = (state) => state.studentsByGroup;

const selectClassId = createSelector(
    [selectStudentsByGroup],
    (studentsByGroup) => studentsByGroup && studentsByGroup.id
);

const selectGroupsAndStudents = createSelector(
    [selectStudentsByGroup],
    (studentsByGroup) => studentsByGroup && studentsByGroup.groups
);

const selectGroupById = (groupId) =>
    createSelector(
        [selectGroupsAndStudents],
        (groups) => groups && groups.find((group) => group.id === groupId)
    );

const selectStudentsForGroup = (groupId) =>
    createSelector(
        [selectGroupById(groupId)],
        (group) => group && group.students
    );

const selectGroupForStudent = (studentId) =>
    createSelector(
        [selectGroupsAndStudents],
        (groups) =>
            groups &&
            groups.find(
                (group) =>
                    group.id !== ALL_GROUPS &&
                    group.students.find(
                        (student) => student.value === studentId
                    )
            )
    );

export default {
    selectStudentsByGroup,
    selectClassId,
    selectGroupsAndStudents,
    selectGroupById,
    selectStudentsForGroup,
    selectGroupForStudent
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/students-by-group/students-by-group-selectors.js